<template>
  <el-main class="page-content-margin-unset">
    <el-table border :data="body">
      <el-table-column label="手机号">
        <template slot-scope="scope">
          <el-select
            filterable
            remote
            reserve-keyword
            :remote-method="chageSelectUser"
            v-model="scope.row.user_uuid"
            :loading="loading"
            @change="setUserChange"
          >
            <el-option
              v-for="item in userOpation"
              :key="item.uuid"
              :label="item.mobile"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="用户昵称">
        <template slot-scope="scope">
          <label>{{scope.row.nickname}}</label>
        </template>
      </el-table-column>
      <el-table-column label="订单金额">
        <template slot-scope="scope">
          <label>{{scope.row.money}}</label>
        </template>
      </el-table-column>
      <el-table-column label="实际支付金额">
        <template slot-scope="scope">
          <el-input class="dk-input" v-model="scope.row.paid_money"/>
        </template>
      </el-table-column>
    </el-table>
    <h3>收货地址</h3>
    <el-table border :data="address">
      <el-table-column prop="name" label="收货人">
        <template slot-scope="scope">
          <el-input v-model="scope.row.name"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话">
        <template slot-scope="scope">
          <el-input v-model="scope.row.mobile"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="收货地址 (省-市-区)">
        <template slot-scope="scope">
          <el-cascader
            v-model="scope.row.address_arr"
            :options="cityList"
            :props="{ value: 'name',label:'name',children:'districts', checkStrictly: true }"
            filterable></el-cascader>
        </template>
      </el-table-column>
      <el-table-column label="收货地址 (地址)">
        <template slot-scope="scope">
          <!-- <span>
            {{ scope.row.province }}
            {{ scope.row.city }}
            {{ scope.row.county }}
            {{ scope.row.detail_address }}
          </span>-->
          <el-input v-model="scope.row.detail_address"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <h3>商品信息</h3>
    <el-table border :data="product">
      <!-- <el-table-column label="商品图片">
        <template slot-scope="scope">
          <img width="148px" :src="imgDomain + scope.row.img_src" alt />
        </template>
      </el-table-column>-->

      <el-table-column align="center" prop="product_name" label="商品标题">
        <template slot-scope="scope">
          <el-select
            filterable
            remote
            reserve-keyword
            :remote-method="chageSelectGoods"
            v-model="product[scope.$index].product_uuid"
            :loading="loading"
            @change="(value) => setGoodsNormAtChange(value, scope.$index)"
          >
            <el-option
              v-for="item in goodsOpation"
              :key="item.uuid"
              :label="item.title"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="standard_name" label="商品规格">
        <template slot-scope="scope">
          <el-select
            v-model="product[scope.$index].standard_uuid"
            @change="(value) => changeStandard(value, scope.$index)"
          >
            <el-option
              v-for="item in goodsNormOpation[scope.$index]"
              :key="item.uuid"
              :label="item.name"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量">
        <template slot-scope="scope">
          <el-input
            :disabled="scope.row.standard_uuid === '' || scope.row.product_uuid === '' ||
                        scope.row.standard_uuid === undefined || scope.row.product_uuid === undefined"
            v-model="scope.row.quantity"
            @change="event().quantityChangeEvent(scope.$index)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="event().removeProductTableRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" style="text-align: center;">
      <el-button @click="event().addProductTableRow()" style="width:100%">新 建</el-button>
    </el-col>

    <el-col :span="24" style="text-align: center;margin-top:20px">
      <el-button @click="event().returnBackPage()">返 回</el-button>
      <el-button type="primary" @click="saveOrderEdit()">保 存</el-button>
    </el-col>
  </el-main>
</template>

<script>
import { saveOrder } from "../../api/order";
import { imgDomain } from "../../configs/env";
import { getStandardList, getCommodityList } from "../../api/commodity";
import { getUserList, getUserDetail } from "../../api/user";

import {
  getCity
} from '../../api/content'
export default {
  data() {
    // eslint-disable-next-line
    return {
      imgDomain,
      loading: false,
      body: [{
        user_uuid: '',
        name: '',
        money: '0',
        paid_money: '0',
      }],
      address: [{
        name: '',
        mobile: '',
        address_arr: [],
        detail_address: '',
      }],
      userOpation: [],
      cityList: [],
      product: [],
      goodsOpation: [],
      goodsNormOpation: [],
      tempPrice: 0,
    };
  },
  created() {
    this.network().getCity()
    this.network().getUserList();
    this.network().getCommodityList();
    console.log(this.body)
  },
  mounted() {
    // this.network().getCommodityList();
  },
  methods: {
    chageSelectUser(value) {
      this.network().getUserList(value);
    },
    setUserChange (value) {
      this.network().getUserDetail(value);
    },
    setGoodsNormAtChange(value, index) {
      this.$set(this.product[index],'standard_uuid', '')
      this.$set(this.product[index],'paid_money', 0)
      this.network().getStandardList(value, index);
      this.event().countPrice();
    },
    changeStandard(value, index) {
      this.event().quantityChangeEvent(index)
    },
    chageSelectGoods(value) {
      this.network().getCommodityList(value);
    },
    saveOrderEdit() {
      let params = {}
      if (this.address[0].detail_address === '') {
        return this.$message('详细地址不能为空');
      }
      params.user_uuid = this.body[0].user_uuid
      params.name = this.address[0].name;
      params.mobile = this.address[0].mobile;
      params.address = this.address[0].address_arr.join(' ') + ' ' + this.address[0].detail_address;
      params.money = this.body[0].money;
      params.paid_money = this.body[0].paid_money;
      params.product =  this.product;
      console.log(params)
      this.network().saveOrder(params);
    },
    event() {
      return {
        quantityChangeEvent: (index) => {
          let nromuuid = this.product[index].standard_uuid;
          console.log(nromuuid);
          let singPrice = 0.0;
          this.goodsNormOpation[index].forEach((item) => {
            if (item.uuid === nromuuid) {
              singPrice = parseFloat(item.price);
            }
          });
          console.log(singPrice, "单价");
          if (singPrice === 0) {
            if (this.tempPrice === 0) {
              this.tempPrice = parseFloat(this.product[index].price);
            }

            this.product[index].paid_money =
              this.tempPrice * parseFloat(this.product[index].quantity);
          } else {
            this.product[index].paid_money =
              parseFloat(this.product[index].quantity) * singPrice;
          }
          this.event().countPrice();
        },
        countPrice: () => {
          //计算总金额
          let orderCount = 0;
          this.product.forEach((item) => {
            orderCount += parseFloat(item.paid_money);
          });
          this.body[0].money = orderCount;
          this.body[0].paid_money = orderCount;
        },
        returnBackPage: () => {
          this.$router.push({ path: "list" });
        },
        removeProductTableRow: (index) => {
          let uuid = this.product[index].uuid;
          if (uuid) {
            this.delete_product.push(uuid);
          }
          this.product.splice(index, 1);
          this.goodsNormOpation.splice(index, 1);
          this.event().countPrice();
        },
        addProductTableRow: () => {
          this.product.push({
            img_src: "",
            paid_money: "",
            price: "",
            product_name: "",
            quantity: 0,
            standard_name: "",
          });
        },

        onChangMoneyClick: () => {
          this.changeMoneyBody.paid_money = this.body[0].paid_money;
          this.changeMoneyBody.uuid = this.body[0].order_uuid;
          this.changeMoneyDialog = true;
        },
        onSureChangeMoneyClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().chengMoney();
            } else {
              console.log("error submit!!");
            }
          });
        },
      };
    },
    network() {
      return {
        getCity: async () => {
          const { status, data } = await getCity()
          if (status !== 200) return
          for (let item of data) {
            for (let i of item.districts) {
              for (let j of i.districts) {
                delete j.districts
              }
            }
          }
          this.cityList = data
        },
        getUserList: async (value) => {
          let params = {
          };
          if (value) {
            params.keyword = value;
          }
          const { status, data } = await getUserList(params);
          this.userOpation = data.data;
        },
        getUserDetail: async (value) => {
          const { status, data } = await getUserDetail(value);
          this.$set(this.body[0], 'nickname', data.nickname)
        },
        saveOrder: async (params) => {
          const { status, data } = await saveOrder(params);
          if (status !== 200) return
          this.$notify({
            title: '新增成功',
            message: '新增订单成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        getStandardList: async (value, index) => {
          let params = {
            product_uuid: value,
          };
          const { status, data } = await getStandardList(params);
          this.$set(this.goodsNormOpation, index, data.list);
        },
        getCommodityList: async (value) => {
          let params = {
            status: 0,
          };
          if (value) {
            params.keyword = value;
          }
          const { status, data } = await getCommodityList(params);
          this.goodsOpation = data.data;
        },
        chengMoney: async () => {
          const { status } = await chengMoney(this.changeMoneyBody);
          if (status !== 200) return;
          this.network().getOrderDetail();
          this.changeMoneyDialog = false;
          this.$notify({
            title: "修改成功",
            message: "实际金额修改成功",
            type: "success",
          });
        },
      };
    },
    handler() {
      return {};
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/mixins.scss";
.page-content-margin-unset {
  .dk-from {
    display: flex;
  }
  .table-top {
    @include dk-table-top;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/order/order-add.vue